<script setup lang="ts">
import { showDeleteChatDialogue } from "@/components/Dialogues/useData/useDialogues";

import { chatStatus } from "@/views/Home/useData/module/chat";

const endEdit = () => {
  showDeleteChatDialogue.value = false;
};
</script>

<template>
  <el-dialog
    v-model="showDeleteChatDialogue"
    width="300"
    class="custom"
    align-center
    center
    :show-close="false"
  >
    <template v-slot:header> </template>
    <div class="content">
      <div class="title">确定删除对话吗？</div>
      <div class="input-content">
        删除后该对话记录无法恢复和找回，请谨慎操作。
      </div>
    </div>
    <template v-slot:footer>
      <div class="footer">
        <el-button @click="showDeleteChatDialogue = false" type=""
          >取消
        </el-button>

        <el-button type="primary" @click="endEdit">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<style lang="scss" scoped>
.custom {
  :deep(.el-dialog__header) {
    display: none !important;
  }
  .el-dialog__header {
    display: none !important;
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 30px;
    }

    .input-content {
      padding: 0 10px;

      width: 100%;
      height: 40px;
      font-size: 14px;
    }
  }

  .footer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
  }
}
</style>
